import React, { useState } from 'react';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@material-ui/core';
import useStyles from './DnDTable.styled';
import i18n from 'i18n-js';
import DragIndicatorIcon from '@material-ui/icons/DragIndicator';

export const DnDtable = ({ data, onUpdate, columns, editable, headerCellAlign }) => {
  const classes = useStyles();
  const [rowWidths, setRowWidths] = useState({});

  const handleDragEnd = (result) => {
    if (!result.destination) {
      return;
    }

    if (result.destination.index === result.source.index) {
      return;
    }

    const values = [...data];
    const item = values[result.destination.index];

    values[result.destination.index] = values[result.source.index];
    values[result.source.index] = item;

    onUpdate(values);
  };

  const onBeforeDragStart = (rowData) => {
    const id = rowData['draggableId'];
    const row = document.getElementById(id);
    if (row) {
      setRowWidths({
        ...rowWidths,
        [id]: row.clientWidth,
      });
    }
  };

  const getRowContent = (col, rowData, position) => {
    let data = '---';
    const selector = col['selector'] || null;
    if (!selector) {
      return data;
    }

    data = col.cell(rowData, position);
    return data;
  };

  const getColumnsDefinitions = () => {
    const columnsData = [...columns];
    columnsData.shift();
    return columnsData;
  };

  const CustomCell = ({ col, item, className, index }) => {
    return (
      <TableCell className={className} align={col['align'] || 'left'}>
        {getRowContent(col, item, index)}
      </TableCell>
    );
  };

  const CustomRow = ({ index, draggableProvided, snapshot, item }) => {
    return (
      <TableRow
        id={`drag-row-${index}`}
        ref={draggableProvided.innerRef}
        {...draggableProvided.draggableProps}
        style={{
          ...draggableProvided.draggableProps.style,
          width: snapshot.isDragging
            ? getRowWidth(index)
            : draggableProvided.draggableProps.style.width,
          background: snapshot.isDragging ? 'rgba(245,245,245, 0.75)' : 'none',
        }}
      >
        <TableCell align="left" className={classes.orderCol}>
          <div
            className="iconContainer"
            style={{
              display: editable ? 'inline-block' : 'none',
            }}
            {...draggableProvided.dragHandleProps}
          >
            <DragIndicatorIcon className={classes.orderIcon} />
          </div>
          <span className={classes.orderNumber}>{index + 1}</span>
        </TableCell>

        {getColumnsDefinitions().map((col, position) => (
          <CustomCell
            {...{ col, index, position, item }}
            className={classes.col}
            key={`row-cell-${index}-${position}`}
          />
        ))}
      </TableRow>
    );
  };

  const getRowWidth = (index) => {
    const item = rowWidths[`drag-row-${index}`];
    return item;
  };

  const NoDataComponent = () => {
    return (
      <TableRow>
        <TableCell colSpan={7} align="center">
          <div style={{ padding: '24px' }}>{i18n.t('common.no_records_to_display')}</div>
        </TableCell>
      </TableRow>
    );
  };

  return (
    <TableContainer>
      <Table>
        <colgroup>
          {columns.map((item, index) => (
            <col key={`items-${index}`} style={item?.style ? item.style : { width: '35%' }} />
          ))}
        </colgroup>
        <TableHead>
          <TableRow className={classes.head}>
            {columns.map((item, index) => (
              <TableCell align={item.align || 'left'} key={`col-${index}`}>
                {item.name}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <DragDropContext onDragEnd={handleDragEnd} onBeforeDragStart={onBeforeDragStart}>
          <Droppable droppableId="droppable" direction="vertical">
            {(droppableProvided) => (
              <TableBody ref={droppableProvided.innerRef} {...droppableProvided.droppableProps}>
                {data && data?.length ? (
                  data.map((item, index) => (
                    <Draggable
                      key={`drag-row-${index}`}
                      draggableId={`drag-row-${index}`}
                      index={index}
                    >
                      {(draggableProvided, snapshot) => {
                        return <CustomRow {...{ draggableProvided, snapshot, index, item }} />;
                      }}
                    </Draggable>
                  ))
                ) : (
                  <NoDataComponent />
                )}
                {droppableProvided.placeholder}
              </TableBody>
            )}
          </Droppable>
        </DragDropContext>
      </Table>
    </TableContainer>
  );
};
